import type { SVGProps } from 'react';
import React from 'react';
import { IconEmojiU1F603, IconEmojiU1F610, IconEmojiU1F626, IconEmojiU1F641, IconEmojiU1F642 } from './generated';

export const emojiCharacterToIconComponent: Record<string, React.ComponentType<SVGProps<SVGSVGElement>> | undefined> = {
  '😃': IconEmojiU1F603,
  '😐': IconEmojiU1F610,
  '😦': IconEmojiU1F626,
  '🙁': IconEmojiU1F641,
  '🙂': IconEmojiU1F642,
};
